export const CONTACT_STATUSES = [
    {key: 'unconfirmed', label: 'Unconfirmed', color: '#E0001B'},
    {key: 'waiting', label: 'Waiting for reply', color: '#FFD600'},
    {key: 'confirmed', label: 'Confirmed', color: '#1FAA3C'},
];

export function statusFor(contactStatus) {
    return CONTACT_STATUSES.find(status => status.key === contactStatus);
}
